import { NgOptimizedImage } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { Company } from "../../../domain/model/company.model";
import { Router } from "../../../domain/service/router/router";
import { CdnPipe } from "../pipe/cdn.pipe";
import { FilePipe } from "../pipe/file.pipe";
import { BaseComponent } from "./base.component";

@Component({
	selector: "app-layout-company-logo",
	imports: [NgOptimizedImage, FilePipe, CdnPipe, TranslocoPipe],
	template: `
    <div class="sidebar-logo">
      <a (click)="home()" class="w-12 h-8 block">
        @if (company) {
          <img [ngSrc]="(company.imageId ? (company.imageId | filePath | cdn) : getFallbackLogo())" width="50"
               height="32" [alt]="'layout.companyLogo.alt' | transloco" class="h-8 w-auto max-w-28"/>
        }
      </a>
    </div>
  `,
	styles: [
		`.sidebar-logo {
          display: flex;
          align-items: center;
          position: relative;
          height: 64px;
          padding-left: 24px;
          overflow: hidden;
          line-height: 64px;
          background: #001529;
          transition: all .3s;
        }`,
	],
})
export class LayoutCompanyLogoComponent extends BaseComponent {
	@Input() company: Company | undefined;

	constructor(private readonly router: Router) {
		super();
	}

	async home(): Promise<void> {
		await this.router.navigate(["/" + this.router.namespace(), "inicio"]);
	}

	getFallbackLogo(): string {
		return this.company?.type === "client" &&
			this.company?.companyClientType === "regular"
			? "/images/logo-leroy.png"
			: "/images/salimer.png";
	}
}
